
































































































import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';
import { IContactRequest, contactRequest } from '../../api/';
import { apiErrorHelper } from '../../api/apiErrorHelper';
import { validation } from '../../lib/validation';

export default {
  name: 'ContactUs',
  data() {
    return {
      valid: false,
      subject: '',
      subjectRules: [
        (v) => validation.valueRequired(v) || this.fields.SubjectRequiredMsg.value,
        (v) =>
          validation.length(v, this.fields.SubjectLengthMax.value) ||
          this.fields.SubjectLengthError.value,
        (v) => validation.notSpecialCharacters(v) || this.fields.SubjectInvlaidCharacterError.value,
      ],
      email: '',
      emailLengthMax:
        this.fields.EmailLengthMax && this.fields.EmailLengthMax.value
          ? this.fields.EmailLengthMax.value
          : 80,
      emailRules: [
        (v) => validation.valueRequired(v) || this.fields.EmailRequiredMsg.value,
        (v) => validation.emailFormat(v) || this.fields.EmailFormatError.value,
      ],
      phone: '',
      phoneRules: [
        (v) => validation.valueRequired(v) || this.fields.PhoneRequiredMsg.value,
        (v) =>
          validation.length(v, this.fields.PhoneLengthMax.value) ||
          this.fields.PhoneLengthError.value,
        (v) => validation.onlyNumerals(v) || this.fields.PhoneFormatMsg.value,
      ],
      contactPreference: '',
      contractPreferenceRules: [(v) => !!v || this.fields.PreferredContactMethodErrorMsg.value],
      enquiry: '',
      enquiryRules: [
        (v) => validation.valueRequired(v) || this.fields.YourQueryErrorMsg.value,
        (v) =>
          validation.length(v, this.fields.YourQueryLengthMax.value) ||
          this.fields.YourQueryLengthError.value,
        (v) =>
          validation.notSpecialCharacters(v) || this.fields.YourQueryInvlaidCharacterError.value,
      ],
      loading: false,
    };
  },
  methods: {
    async submitForm() {
      this.loading = true;
      const body: IContactRequest = {
        source: 'IOL',
        email: this.email,
        mobile: this.phone,
        subject: this.subject,
        description: this.enquiry,
        preferredContactMethod: this.contactPreference,
      };
      try {
        const response = await contactRequest(body);
        if (response.success) {
          this.loading = false;
          this.$router.push({ path: '/contactsuccess' });
          this.$store.dispatch('analytics', {
            actionName: 'contactus-form-complete',
            entityChange: 'IOL ContactUs Form',
          });
        }
      } catch (error) {
        this.loading = false;
        apiErrorHelper(this.$router, error);
      }
    },
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ScText: Text,
    ScRichText: RichText,
  },
};
